import { render, staticRenderFns } from "./TenantDetailForm.vue?vue&type=template&id=681ee252&"
import script from "./TenantDetailForm.vue?vue&type=script&lang=js&"
export * from "./TenantDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./TenantDetailForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports